import { Provider } from "../../../order";
import { CompensationMethod, ReturnTypeEnum } from "../../../return";
import { SchemaInstance, defineSchema } from "../../type-system/schema";

export const returnProcessingSchema = defineSchema({
  fields: {
    returnId: {
      dataType: "Text",
      documentation: "The unique identifier for the return in Redo",
      hideFromConditionStep: true,
      hideFromInsertionModal: true,
    },
    compensationMethod: {
      dataType: "Multiple Enum",
      documentation: "The method of compensation for the return",
      values: Object.values(CompensationMethod),
    },
    customerRequestType: {
      dataType: "Enum",
      documentation: "The type of the return",
      values: Object.values(ReturnTypeEnum),
    },
    returnTags: {
      dataType: "Multiple Text",
      documentation: "Tags associated with the return",
    },
    returnTotalValue: {
      dataType: "Text",
      documentation:
        "The total value of the return including taxes and adjustments",
    },
    provider: {
      dataType: "Enum",
      documentation:
        "The ecommerce provider for this return (e.g., shopify, commentsold, bigcommerce)",
      values: Object.values(Provider),
    },
    skus: {
      dataType: "Multiple Text",
      documentation: "The SKUs of the products being returned",
    },
    productTags: {
      dataType: "Multiple Text",
      documentation: "The tags of all the products in the return",
    },
    returnReasons: {
      dataType: "Multiple Text",
      documentation: "The reasons provided for each product being returned",
    },
    merchantCreated: {
      dataType: "Boolean",
      hideFromInsertionModal: true,
      documentation: "Whether the return was created by the merchant",
    },
    greenReturn: {
      dataType: "Boolean",
      hideFromInsertionModal: true,
      documentation:
        "Whether the return is a green return (customer keeps all items)",
    },
  },
});

export const exampleReturnProcessingSchemaInstance: SchemaInstance<
  typeof returnProcessingSchema
> = {
  returnId: "65b81f41da22f4000718b34e",
  compensationMethod: [CompensationMethod.REFUND],
  customerRequestType: ReturnTypeEnum.RETURN,
  returnTags: ["high-value"],
  returnTotalValue: "$100.00",
  provider: Provider.SHOPIFY,
  skus: ["SKU-1"],
  productTags: ["tag1"],
  returnReasons: ["Does not fit"],
  merchantCreated: false,
  greenReturn: false,
};
